if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.isBundle = this.dataset.bundleGifts === 'true';

        this.sectionId = this.dataset.sectionId;

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        this.productInfo = this.closest('product-info, quickview-container');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.submitButton.addEventListener('click', this.onSubmitButtonClick.bind(this));

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitButtonClick(event) {
        if(this.submitButton.getAttribute('data-notify') === 'true') {
          event.preventDefault();

          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
          this.querySelector('.loading__spinner').classList.remove('hidden');

          const sku = this.submitButton.getAttribute('data-sku');

          const payload = {
            sku: sku,
            email: window.customer.email,
          };

          fetch(`https://flow.zoho.com/692924205/flow/webhook/incoming?zapikey=1001.d88e561bb1a5dad622b736e3a52150ed.a1ff7225102c2e3f1aff17c7ba7b27cd&isdebug=false`, {
            method: 'POST',
            body: JSON.stringify(payload),
          })
          .then(response => response.json())
          .then(data => {
            console.log(data);
          })
          .catch(error => {
            console.error(error);
          })
          .finally(() => {
            this.submitButton.setAttribute('aria-disabled', false);
            this.submitButton.classList.remove('loading');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });

          return false;
        }
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        const formData = new FormData(this.form);
        const quantity = formData.get('quantity');

        let warehouse = formData.get('properties[warehouse]');
        const warehouseInfo = this.productInfo.getWarehouseInfo();

        if(warehouseInfo && warehouseInfo.inventory < quantity) {
          formData.set('properties[exceeds_stock]', true);
        }
        else {
          formData.set('properties[exceeds_stock]', false);
        }

        if(warehouse == null) {
          const quickviewContainer = document.querySelector('quickview-container');

          if(quickviewContainer) {
            const warehouseSelect = quickviewContainer.querySelector('[name="properties[warehouse]"]');
            formData.set('properties[warehouse]', warehouseSelect.value);
            warehouse = warehouseSelect.value;
          }
        }        

        const userAction = await this.showWarehouseWarning(warehouse);        

        if(userAction) {
          if(warehouse !== null) {
            window.selected_warehouse = warehouse;
          }

          if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

          this.handleErrorMessage();

          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
          this.querySelector('.loading__spinner').classList.remove('hidden');

          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          } else {
            formData.append('sections_url', window.location.pathname);
            formData.append('sections', ['cart-icon-bubble']);
          }

          let productId = formData.get('id');

          if (this.isBundle) {
            let product_data = JSON.parse(this.dataset.bundle);

            product_data.forEach((item, index) => {
              if (item.id == productId) {
                formData.append(
                  `properties[_bundleSize]`,
                  item.properties._bundleSize
                );
                formData.append(
                  `properties[_bundleGift]`,
                  item.properties._bundleGift
                );
                formData.append(`properties[_gui]`, item.properties._gui);
              } else {
                formData.append(`items[${index}][id]`, item.id);
                formData.append(`items[${index}][quantity]`, item.quantity);
                formData.append(
                  `items[${index}]properties[_gui]`,
                  item.properties._gui
                );
                formData.append(
                  `items[${index}]properties[_bundleSize]`,
                  item.properties._bundleSize
                );
                if (item.properties._bundleGift) {
                  formData.append(
                    `items[${index}]properties[_bundleGift]`,
                    item.properties._bundleGift
                  );
                }
              }
            });
          }

          config.body = formData;

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (this.sectionId == 'Quickview') {
                document.querySelector('#Quickview').remove();
              }

              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);

                const soldOutMessage =
                  this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButtonText.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              }

              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: response,
                });
              this.error = false;

              if (this.cart) {
                this.cart.renderContents(response);
              } else {
                const cartBubble = document.querySelector('#cart-icon-bubble');

                if (response.sections['cart-icon-bubble']) {
                  const html = new DOMParser().parseFromString(
                    response.sections['cart-icon-bubble'],
                    'text/html'
                  );
                  cartBubble.querySelector(
                    '.cart-count-bubble__count'
                  ).innerHTML = html.querySelector(
                    '.cart-count-bubble__count'
                  ).innerHTML;
                }
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty'))
                this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading__spinner').classList.add('hidden');
            });
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      showWarehouseWarning(warehouse) {
        return new Promise((resolve) => {
          if(warehouse === null || window.selected_warehouse === "") {
            resolve(true);
          }
          else if(warehouse && warehouse === window.selected_warehouse) {
            resolve(true);
          }
          else {
            fetch(`${window.location.pathname}?section_id=warehouse-warning`)
            .then(response => response.text())
            .then(responseText => {
              const html = new DOMParser().parseFromString(
                responseText,
                'text/html'
              );

              const oldModal = document.querySelector('#WarehouseWarning');
              if (oldModal) {
                oldModal.remove();
              }

              const modal = html.querySelector('#WarehouseWarning');
              document.body.appendChild(modal);              

              modal.show();

              document.getElementById('WarehouseWarning-confirm').addEventListener('click', () => {
                document.body.removeChild(modal);
                resolve(true);
              });

              document.getElementById('WarehouseWarning-cancel').addEventListener('click', () => {
                document.body.removeChild(modal);
                resolve(false);
              });
            });
          }
        });          
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
